<div class="affiliates-claim-modal__top">
  <div class="affiliates-claim-modal__top--wrapper">
    <div class="affiliates-claim-modal__top--text">
      Claim your Free
      <svg-icon
        class="flex items-center justify-center"
        src="assets/icons/core/skins.svg"
      ></svg-icon>
      1 Coin and 3 Free Cases
    </div>
    <span class="affiliates-claim-modal__top--line"></span>
    <div class="affiliates-claim-modal__top--background"></div>
  </div>
</div>
<p class="affiliates-claim-modal__description">
  In order to claim you will need to fulfill the requirements below:
</p>
<div class="affiliates-claim-modal__requirements">
  <div class="affiliates-claim-modal__requirement">
    <app-checkbox
      class="affiliates-claim-modal__requirement--checkbox"
      [disabled]="true"
      [checked]="
        !!affiliatesService.userStatsResource.value()?.ref_by ||
        !!affiliatesService.userStatsResource.value()?.ref_next
      "
    >
      <p class="affiliates-claim-modal__requirement--description">
        Use an <span>Affiliate</span> code
      </p></app-checkbox
    >
  </div>
  <div class="affiliates-claim-modal__requirement">
    <app-checkbox
      class="affiliates-claim-modal__requirement--checkbox"
      [disabled]="true"
      [checked]="(sessionService.profile()?.level ?? 0) >= 5"
      ><p class="affiliates-claim-modal__requirement--description">
        Be Level 5 on
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/ui/steam.svg"
        ></svg-icon>
        <span> Steam</span>
      </p></app-checkbox
    >
  </div>
  <div class="affiliates-claim-modal__requirement">
    <app-checkbox
      class="affiliates-claim-modal__requirement--checkbox"
      [disabled]="true"
      [checked]="
        sessionService.discord().linked && sessionService.discord().joined
      "
    >
      <p class="affiliates-claim-modal__requirement--description">
        Join our
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/socials/discord.svg"
        ></svg-icon>
        <span>Discord</span> server and
        <span
          (click)="$event.stopPropagation(); sessionService.authDiscord()"
          style="cursor: pointer"
        >
          VERIFY
        </span>
        you joined
      </p>
    </app-checkbox>
  </div>
</div>
<form
  class="affiliates-claim-modal__claim-form"
  (submit)="handleClaimAffiliateCode($event)"
>
  <s-form-field
    label="Affiliate Code"
    placeholder="Type your code..."
    id="affiliate-code"
    [field]="codeForm.code"
    [error]="codeFormApiError()"
    [errorType]="'outline'"
  />
  <button
    [disabled]="codeForm().submitting() || codeForm().invalid()"
    class="affiliates-claim-modal__claim-form--submit-button"
    type="submit"
  >
    Reedem Code
  </button>
</form>
<div class="affiliates-claim-modal__prizes">
  <div class="affiliates-claim-modal__prize">
    <img
      class="affiliates-claim-modal__prize--image"
      [src]="affiliatesService.affiliateCase()?.image"
      [alt]="affiliatesService.affiliateCase()?.name"
    />
    <p class="affiliates-claim-modal__prize--name">
      {{ affiliatesService.affiliateCase()?.name }}
    </p>
    <button
      class="affiliates-claim-modal__prize--button"
      [class.green]="affiliatesService.isAffiliateCaseAvailable()"
      [class.black]="!affiliatesService.isAffiliateCaseAvailable()"
      [routerLink]="[
        '/affiliates/cases',
        affiliatesService.affiliateCase()?.link
      ]"
      [disabled]="!affiliatesService.isAffiliateCaseAvailable()"
      (click)="affiliatesService.isAffiliateCaseAvailable() && closeModal()"
    >
      {{
        affiliatesService.isAffiliateCaseAvailable() ? "Claim" : "Unavailable"
      }}
    </button>
  </div>
  <div class="affiliates-claim-modal__prize">
    <img
      class="affiliates-claim-modal__prize--image"
      src="assets/images/affiliates/affiliates-coins.png"
      alt="Prize 2"
    />
    <p class="affiliates-claim-modal__prize--name">
      1
      <svg-icon
        class="flex items-center justify-center"
        src="assets/icons/core/skins.svg"
      ></svg-icon>
      free coins
    </p>
    <button
      class="affiliates-claim-modal__prize--button"
      [class.green]="affiliatesService.bonuses()?.balance"
      [class.black]="!affiliatesService.bonuses()?.balance"
      (click)="claimBalance()"
      [disabled]="!affiliatesService.bonuses()?.balance"
    >
      {{ affiliatesService.bonuses()?.balance ? "Claim" : "Unavailable" }}
    </button>
  </div>
</div>
<button class="affiliates-claim-modal__refresh" (click)="refreshBalance()">
  Refresh
</button>
